const makeConstant = (constant) => `embed/${constant}`

export const UPDATE_EMBED = makeConstant('UPDATE_EMBED')

export const ConfigurationProperty = Object.freeze({
  CHAT_ENABLED: 'chatEnabled',
})
